
import { Component, Watch } from 'vue-property-decorator';
import BaseAuthenticatedView from '@/views/BaseAuthenticatedView.vue';
import SubscriptionPlan from '@/models/subscription/SubscriptionPlan';
import SubscriptionEntry, { SubscriptionStatus } from '@/models/subscription/SubscriptionEntry';
import DateFormatter from '@/mixins/dateFormatterMixin';
import IdealConfirmationService from '@/services/ideal-confirmation/idealConfirmationService';
import PaymentMethod from '@/models/payment-method/PaymentMethod';

@Component({
  components: {
    DowngradeStripeSubscriptionDialog: () =>
      import('./downgrade-stripe-subscription/DowngradeStripeSubscriptionDialog.vue'),
    DowngradeLocalSubscriptionDialog: () =>
      import('./downgrade-local-plan/DowngradeLocalSubscriptionDialog.vue'),
    UpgradeSubscriptionDialog: () =>
      import('@/components/subscription/upgrade-subscription-plan/UpgradeSubscriptionDialog.vue'),
    ChangeSubscriptionDialog: () => import('./change-plan/ChangePlanDialog.vue'),
  },
  mixins: [DateFormatter],
})
export default class Plans extends BaseAuthenticatedView {
  handlePlanChange(plan: SubscriptionPlan) {
    this.selectedPlan = plan; // Set the selected plan
    if (plan.priority > this.currentSubscriptionPlan.priority) {
      this.showUpgradeSubscriptionDialog = true;
    } else {
      this.showDowngradeSubscriptionDialog = true;
    }
    // Check for a paylink and redirect if it exists
    if (plan.paylink) {
      window.location.href = plan.paylink;
    }
  }

  // 🚩 Flag for whether the downgrade subscription dialog should be shown
  private showDowngradeSubscriptionDialog: boolean = false;

  // 🚩 Flag for whether thw upgrade subscription dialog should be shown
  private showUpgradeSubscriptionDialog: boolean = false;

  // 🚩 Flag for whether thw upgrade subscription dialog should be shown
  private showChangeSubscriptionPlanDialog: boolean = false;

  // 📦 The selected plan the user wants to upgrade / downgrade
  private selectedPlan: SubscriptionPlan | null = null;

  // 📦 The current Stripe subscription of the user
  private get subscription(): SubscriptionEntry | null {
    if (this.$store.state.payments.currentSubscription) {
      return this.$store.state.payments.currentSubscription;
    }
    return null;
  }
  // 📦 The payment method of the current user
  private get currentPaymentMethod(): PaymentMethod {
    return this.$store.state.payments.currentPaymentMethod;
  }

  // 📦 The current subscription plan of the user
  private get currentSubscriptionPlan(): SubscriptionPlan {
    return this.$store.getters.currentSubscriptionPlanWithPriority;
  }

  // 🚩 Flag for whether the "active until" label for the subscription
  private get showSubscriptionActiveUntilLabel(): boolean {
    return (
      this.subscription != null &&
      this.subscription!!.cancelAtPeriodEnd &&
      this.subscription!!.nextBillingDate != null
    );
  }

  // 📦 All the available subscription plans for the current user
  private get availableSubscriptionPlans(): SubscriptionPlan[] {
    let plans: SubscriptionPlan[] = this.$store.state.subscription.availableSubscriptionPlans;
    plans = plans.sort(
      (planA: SubscriptionPlan, planB: SubscriptionPlan) => planA.priority - planB.priority
    );
    return plans;
  }

  // 🚩 Flag for whether the subscription dropdown menu should be shown
  private get showDontDowngradePlanOption(): boolean {
    if (!this.currentPaymentMethod) {
      return false;
    }
    return (
      this.subscription != null &&
      this.subscription.cancelAtPeriodEnd &&
      this.subscription.status === SubscriptionStatus.Active
    );
  }

  protected async mounted() {
    super.mounted();
  }

  private updated() {
    new IdealConfirmationService().resolveIdealConfirmationResponse(this.$router);
  }
}
